module.exports = __webpack_public_path__ + "static/media/app-logo-2.2f216af7.png";